"use professional"
function FiltersModal({ close }) {
    return (
      <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(6px)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: '80px', zIndex: 50 }}>
        <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border-glass)', borderRadius: '20px', padding: '28px', width: '380px', maxWidth: '90vw', position: 'relative' }}>
          <div style={{ height: '3px', position: 'absolute', top: 0, left: 0, right: 0, borderRadius: '20px 20px 0 0', background: 'linear-gradient(90deg, var(--accent-cyan), var(--accent-violet))' }} />
          <div style={{ textAlign: 'center' }}>
            <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: 'var(--text-primary)', fontFamily: 'var(--font-display)', marginBottom: '12px' }}>Filter Projects</h3>
            <div style={{ padding: '12px 0' }}>
              <form>{/* Add filter form fields here */}</form>
            </div>
            <button
              onClick={close}
              style={{ width: '100%', padding: '12px', borderRadius: '12px', border: 'none', background: 'linear-gradient(135deg, var(--accent-cyan), var(--accent-violet))', color: '#fff', fontWeight: 600, cursor: 'pointer', fontSize: '0.9rem', transition: 'opacity 0.2s' }}
              onMouseEnter={e => e.target.style.opacity = '0.85'}
              onMouseLeave={e => e.target.style.opacity = '1'}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    )
  }
  
  export default FiltersModal
  
  